module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-rojo.30f97d19.svg";